module.exports = __webpack_public_path__ + "img/chp.972c4c5a.jpg";